import React from 'react'

import Card from '../components/Card'
import TextInput from '../components/TextInput'
import Backdrop from '../components/Backdrop'

export default class Result extends React.Component {
  state = {
    labels: {},
  }

  handleChange = (e, index) => {
    const { labels } = this.state

    const newLabels = {}
    newLabels[index] = e.target.value

    this.setState({
      labels: {
        ...labels,
        ...newLabels,
      },
    })
  }

  render() {
    const { images } = this.props
    const { labels } = this.state
    return (
      <Card>
        <h1>📸 Backdrop</h1>
        <p>Because screenshots were meant to be lit</p>
        <Backdrop
          screenshots={images.map((image, index) => ({
            image,
            label: labels[index] || `Image ${index + 1}`,
          }))}
        />
        <div className="textFields">
          {images.map((_, index) => (
            <TextInput onChange={e => this.handleChange(e, index)} />
          ))}
        </div>
      </Card>
    )
  }
}
